import { z } from 'zod';

export const checkinMailFormSchema = z.object({
  email: z
    .string()
    .min(1, 'Emailは必須です。')
    .email('Emailを正しいメールアドレスにしてください。')
    .max(255),
  is_status: z.boolean().optional(),
  add_sentence: z.string().max(250).optional(),
  remarks: z.string().optional(),
});

export type CheckinMailFormSchema = z.infer<typeof checkinMailFormSchema>;
